(function () {
    'use strict';

    angular
        .module('app')
        .controller('LogController', LogController);

    LogController.$inject = ['API', 'alert', 'debug', 'helpers', '$stateParams', 'ListViewSearchExtension',];

    function LogController(API, alert, debug, helpers, $stateParams, ListViewSearchExtension) {
        var vm = this;

        ListViewSearchExtension.extendScope(vm);
        vm.listObject.filter = {};
        vm.listObject.filter.sort = 'createdAscending';
        vm.listObject.filter.admin = '';
        vm.listObject.filter.action = '';
        vm.listObject.filter.targetModel = '';
        vm.listObject.perPage = 20;
        vm.loadingState = {
            logs: false,
            iusAdmins: false,
        };

        vm.loadResources = loadResources;
        vm.seeChanges = seeChanges;
        vm.keyUp = keyUp;
        vm.logs = [];
        vm.admins = [];
        vm.actions = [
            'create',
            'delete',
            'update',
        ];
        vm.targetModels = [
            'campaign',
            'contract',
            'game',
            'group',
            'login_iusadmin',
            'login_student',
            'login_teacher',
            'login_thirdparty',
            'school',
            'subscription',
            'subscription_plan',
            'user',
        ];

        activate();

        function activate() {
            if ($stateParams.searchObject) {
                vm.loadParams(JSON.parse($stateParams.searchObject));
            }

            loadResources(true);
            loadIusAdmins();
        }

        function loadIusAdmins() {
            vm.loadingState.iusAdmins = true;
            var promise = API.User.search({ user_type: 'iusadmin' }).$promise;

            promise.then(function (response) {
                vm.admins = response.items;
            }, function (response) {
                debug.log(response);
            })
            .finally(function() {
                vm.loadingState.iusAdmins = false;
            });
        }

        function loadResources(skipCharacterLimit) {
            var promise = null;

            var searchObject = {
                'page': vm.listObject.page,
                'per-page': vm.listObject.perPage,
                'expand': 'user,target',
            };
            if (vm.listObject.filter) {
                switch (vm.listObject.filter.sort) {
                    case 'createdAscending':
                        searchObject.sort = '-created';
                        break;
                    case 'createdDescending':
                        searchObject.sort = 'created';
                        break;

                    default:
                        break;
                }
            }

            if (vm.listObject.filter.targetModel) {
                searchObject.target_model = vm.listObject.filter.targetModel;
            }

            if (vm.listObject.filter.admin) {
                searchObject.user_id = vm.listObject.filter.admin;
            }

            if (vm.listObject.filter.action) {
                searchObject.action = vm.listObject.filter.action;
            }

            if (vm.listObject.searchTerm && (vm.listObject.searchTerm.length > 2 || skipCharacterLimit)) {
                searchObject.q = vm.listObject.searchTerm;
                promise = API.AdminLogs.search(searchObject).$promise;
            } else if (vm.listObject.searchTerm.length === 0) {
                promise = API.AdminLogs.search(searchObject).$promise;
            }

            vm.onSearch();

            if (promise) {
                vm.loadingState.logs = true;
                promise.then(function (response) {
                    vm.logs = response.items;
                    vm.listMeta = response._meta;
                }, function (response) {
                    debug.log(response);
                })
                .finally(function() {
                    vm.loadingState.logs = false;
                });
            }
        }

        function keyUp(event) {
            if (event.keyCode === 13) {
                vm.loadResources(true);
            }
        }

        function seeChanges(log) {
            alert.open('log-changes', { changes: helpers.printObject(log.changes) });
        }

    }
})();